// extracted by mini-css-extract-plugin
export default {"ProfileRejectPage__text":"ProfileReject_ProfileRejectPage__text__EbXy7"};